import type { GameScene } from './GameScene';
import { config } from './defs/config';

export let gameScene: GameScene | undefined = undefined;

export function getGameScene() {
  return gameScene;
}

/**
 * Get the active map row count, falling back to the configured maximum before a scene exists.
 *
 * @returns Number of rows used by the active or default Match2 map.
 */
export function getGameSceneMapRows(): number {
  // Use the active map dimensions when a game session exists.
  return getGameScene()?.sessionEntity.c.map.rows ?? config.map.rows;
}

export function setGameScene(scene: GameScene | undefined) {
  gameScene = scene;
}
